
<template>
	<div class="card-wrapper">
		<a class="cta-card" :href="event.TargetUrl">
			<div class="event" :class="eventCssClass" v-if="event">
				<div class="photo" v-if="event.TeaserImage">
					<img :src="event.TeaserImage" :alt="event.TeaserImageAlt">
				</div>
				<div class="details-container" :class="{ 'has-photo': event.TeaserImage }">
					<div class="date" v-if="event.StartDate">
						<div class="day-number">{{ formatDate(event.StartDate, 'DD') }}</div>
						<div class="month-name">{{ formatDate(event.StartDate, 'MMM') }}</div>
					</div>
					<div class="details">
						<div class="tags" v-if="event.PrimaryTagText" :class="{ 'has-ribbon': event.PrimaryTagRGB }">
							<div class="ribbon" v-if="event.PrimaryTagRGB" :style="'background-color: ' + event.PrimaryTagRGB + ';'"></div>
							<div>{{ event.PrimaryTagText }}</div>
						</div>

						<div class="event-time" v-if="event.FormattedTime">{{ event.FormattedTime }}</div>

						<h3 class="title">{{ event.Title }}</h3>
						<div class="description">{{ event.TeaserSummary }}</div>
						<span class="cta-primary">
							{{ linkText }}
							<svg version="1.1" class="icon-arrow-right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve">
							<path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z" />
                            </svg>
						</span>
					</div>
				</div>
			</div>
		</a>
	</div>
</template>

<script>
	import moment from 'moment';
	import PrimaryCTA from '../Global/PrimaryCTA.vue';

	export default {
		name: 'Event',
		props: ['event', 'layout', 'linkText'], // Add linkText here
		components: {
			PrimaryCTA
		},
		computed: {
			eventCssClass() {
				let classes = [`layout-${this.layout}`];

				if (this.event.IsMultiDay) {
					classes.push('multi-day-event');
					if (this.event.IsStartDay) classes.push('start-day');
					if (this.event.IsEndDay) classes.push('end-day');
					if (!this.event.IsStartDay && !this.event.IsEndDay) classes.push('middle-day');
				}

				return classes.join(' ');
			}
		},
		methods: {
			formatDate: function (date, momentFormatterString) {
				return moment(date, 'YYYY-MM-DD').format(momentFormatterString);
			},
		},
	}
</script>